import { apiUrl } from "helpers/constants/config.constants";
import { httpDelete, httpGet, httpPatch, httpPost } from "./http.service";
import { AxiosResponse } from "axios";

export interface Project {
  projectId: string
  code: string
  userId: string
  name: string
  description: string
  sector: string
  address: string
  addressLink: string
  email: string
  contactPerson?: string
  contactNo?: string
  country: string
  currency: string
  isTest: boolean
  createdBy: string
  createdAt: Date
  updatedBy: string
  updatedAt: Date
  logoImageFiles: {
    s3Url: string
  }[]
  logoImage: string
  coverImageFiles: {
    s3Url: string
  }[]
  coverImage: string
  welcomeMessage: string
  motto: string
  contactEmail: string
  operationDays: string
  operationHours: string
  operationDaysOnsite: string
  operationHoursOnsite: string
  themeColor: string
  buttonColor: string
  serviceColor: string
  offsiteName: string
  externalName: string
  allowExternalBooking: boolean
  allowOffsiteBooking: boolean
  allowCustomerLogin: boolean
  aboutUsEnabled: boolean
  aboutUsContent: Array<{
    imageUrl: string
    title: string
    content: string
  }>
  roleAccess: RoleAccess
  operation: {
    onsite: {
      interval: string,
      hours: {
        time: { openTime: string, closeTime: string }[],
        isOpen: boolean
      }[]
    },
    offsite: {
      interval: string,
      hours: {
        time: { openTime: string, closeTime: string }[],
        isOpen: boolean
      }[]
    }
  },
  metadata: {
    invoiceNotes: string
  }
}

export interface RoleAccess {
  ecommerce: boolean
  booking: boolean
}

export type ShortUrl = {
  shortUrlId: string
  projectId: string
  refId: string
  code: string
  type: string
  metadata?: any
  createdBy: string
  createdAt: Date
  updatedBy: string
  updatedAt: Date
  expiredAt: Date
}

export const getAuthProject = () => {
  return JSON.parse(localStorage.getItem("authProject") as string) as Project;
}

export const doListProject = (skip: number) => {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.project.list, { skip }).then((res) => {
      const response = res as AxiosResponse
      resolve(response);
    }).catch((error) => {
      reject(error);
    })
  });
}

export const doGetProject = (projectId: string) => {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.project.get(projectId)).then((res) => {
      resolve(res)
    }).catch((error) => {
      reject(error)
    })
  })
}

export const doCreateProject = (params: Record<string, unknown>) => {
  return new Promise((resolve, reject) => {
    httpPost(apiUrl.project.create, { ...params }).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error);
    })
  });
}

export const doUpdateProject = (params: Record<string, unknown>) => {
  return new Promise((resolve, reject) => {
    httpPatch(apiUrl.project.update(params.projectId as string), { ...params }).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error);
    })
  });
}

export const doDeleteProject = (id: string) => {
  return new Promise((resolve, reject) => {
    httpDelete(apiUrl.project.delete(id)).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error);
    })
  });
}

export const doGetProductColors = () => {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.setting.listColor).then((res) => {
      resolve(res)
    }).catch((error) => {
      reject(error)
    })
  });
}

export const doGetProjectSetting = () => {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.project.setting.detail).then((res) => {
      resolve(res)
    }).catch((error) => {
      reject(error)
    })
  });
}

export const doPatchProjectSetting = (params: Record<string, unknown>) => {
  return new Promise((resolve, reject) => {
    httpPatch(apiUrl.project.setting.update, { ...params }).then((res) => {
      resolve(res)
    }).catch((error) => {
      reject(error)
    })
  });
}

export function doGetShortUrl(code: string) {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.shortUrl.get(code), {}).then((res) => {
      const response = res as AxiosResponse
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  });
}

export function doGenerateShortUrl(refId: string, type: string) {
  return new Promise((resolve, reject) => {
    httpPost(apiUrl.shortUrl.generate, { refId, type }).then((res) => {
      resolve(res)
    }).catch((error) => {
      reject(error)
    })
  });
}

export function doExpireShortUrl(code: string) {
  return new Promise((resolve, reject) => {
    httpPatch(apiUrl.shortUrl.expire(code), {}).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  });
}